import Vue from 'vue'
import VueKakaoLogin from 'vue-kakao-login';

const API_KEY = '078fb82bc17e7da9f2b7401f63845c85'

export default {
  components: {
    VueKakaoLogin
  },
  computed: {
    kakaoApiKey(){
      return API_KEY
    }
  },
  methods: {
    kakaoRequest(url) {
      const Kakao = window.Kakao
      const defaultOnFailure = () => Vue.prototype.$alert('카카오 요청 실패','Failed','error')
      return new Promise((resolve, reject) => {
        Kakao.API.request({
          url: url,
          success: resolve,
          fail: reject ? reject : defaultOnFailure
        })
      })
    }
  }
}